import UserAdvancedForm from './UserAdvancedForm'

export default UserAdvancedForm
